import { render, staticRenderFns } from "./ModernLoader.vue?vue&type=template&id=575face0&scoped=true&"
import script from "./ModernLoader.vue?vue&type=script&lang=js&"
export * from "./ModernLoader.vue?vue&type=script&lang=js&"
import style0 from "./ModernLoader.vue?vue&type=style&index=0&id=575face0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575face0",
  null
  
)

export default component.exports